module.exports = "data:image/gif;base64,R0lGODlhMgASAJEDAP8Amf9mAP/MAP///yH/C05FVFNDQVBFMi4wAwEAAAAh+QQFFAADACwAAAAAMgASAAACOYSPNsvtD+NKFMiLY0259414ogQe4+mUCsqqFou6cKzOp2yLeP7VfF/6AUHCzK6o8SGTwSWT6IQUAAAh+QQFFAADACwAAAAAHgASAAACLZyPecHtrGJ6NMg76sNSOx55DaiIEImYFrqYbCu+hipnrkzj95vzO9sD/lCqAgAh+QQFFAADACwSAAAAIAASAAACLpyPmcLtrGJ8VMh76sNYO355DSiJEKmYFrqYbCu+iCpnbj3QuF7zsv8CsoQoVQEAIfkEBQoAAwAsJgAAAAwAEgAAAg2cj6nL7Q+jnLTai1UBADs="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading2.gif
// module id = si/C
// module chunks = 1